import ErrorHandler from "@/helpers/handlers/error";
import axios from "axios";
import { store } from "../../store/store";
import { i18n } from "../../main";
import { endpoints } from "@/config/endpoints";
import { ensureCurrentSession, getSessionId } from "@/helpers/auth-session";
const UNPAID_SUBSCRIPTION = "unpaid_subscription";

const forceLogout = error => {
  // Local cleanup happens synchronously; do not show an old error after a
  // delayed server logout has finished and another user has signed in.
  store.dispatch("auth/logout");
  ErrorHandler.displayError(error);
};

export default async (service, customErrorMessage, routeName) => {
  const sessionId = getSessionId();
  try {
    const { data } = await service;
    ensureCurrentSession(sessionId);
    return data;
  } catch (error) {
    ensureCurrentSession(sessionId);
    if (axios.isCancel(error)) {
      ErrorHandler.displayError(error);
      throw error;
    }
    const hasLocallyHandledResponse = Boolean(
      error.response && error.response.data && error.response.data.review
    );

    if (
      error.response &&
      error.response.status === 500 &&
      error.config.url === endpoints.wizard.company.profile
    ) {
      forceLogout(error);
      throw new axios.CanceledError("The session has ended.");
    }

    if (error.response && error.response.status === 401) {
      forceLogout(error);
      throw new axios.CanceledError("The session has ended.");
    }

    if (error.response && error.response.status === 402) {
      const isUnpaidSubscription =
        store.getters["company/isUnpaidSubscription"];
      if (isUnpaidSubscription) {
        return; // Do not show modal if user hasn't selected a subscription plan
      }
      if (error.response.data.detail === UNPAID_SUBSCRIPTION) {
        const data = {
          text: i18n.t("message.service.accountSuspended")
        };
        store.dispatch("settings/openModal", data);
      } else {
        const data = {
          text: i18n.t("message.service.subscriptionPlanExpired"),
          path: "subscription-settings",
          buttonText: i18n.t("message.common.settings")
        };
        if (!["subscription-settings", "legacy-subscription-settings"].includes(routeName)) {
          store.dispatch("settings/openModal", data);
        }
      }

      return;
    }

    if (error.response && error.response.status === 429) {
      const data = {
        text:
          customErrorMessage || i18n.t("message.service.wrongSubscriptionPlan"),
        buttonText: "OK"
      };

      store.dispatch("settings/openModal", data);
      return;
    }

    if (!hasLocallyHandledResponse) {
      ErrorHandler.displayError(error);
    }
    throw error;
  }
};
